<template>
  <div v-if="text || $attrs?.slots?.default" :class="containerClasses">
    <div v-if="text" v-sanitize-html="text"></div>
    <div v-if="$attrs?.slots?.default" v-sanitize-html="$attrs?.slots?.default"></div>
  </div>
</template>

<script lang="ts" setup>
import { getTextClasses } from "@/resources/content/text-styles";
import type { CssFlags } from "@/resources/content/css-flags";
import { getCssFlagsClasses } from "@/resources/content/css-flags";
const BASE_CLASS = "n-content";

defineOptions({
  inheritAttrs: false,
});

interface Props {
  text?: string | null;
  textStyle?: string;
  textColor?: string | null;
  textShadow?: string | null;
  cssFlags?: CssFlags;
}

const props = withDefaults(defineProps<Props>(), {
  textStyle: "body",
  textColor: null,
  textShadow: null,
  cssFlags: () => ({
    xs: [],
    sm: [],
    md: [],
    lg: [],
    xl: [],
  }),
  text: null,
});

const containerClasses = computed(() => [
  BASE_CLASS,
  ...getCssFlagsClasses(props, BASE_CLASS),
  ...getTextClasses(props),
]);
</script>

<style lang="scss">
.n-content {
  margin: 30px 0;
  &--is-centered {
    text-align: center;
  }
  &--marginless {
    margin: 0;
  }

  p {
    min-height: 20px;
  }
}
</style>
